module.exports = __webpack_public_path__ + "img/p-single-1.da35091e.jpg";